import { useCallback } from 'react';

import { useAppDispatch } from 'src/app/store/hooks';
import { authSlice } from 'src/features/auth/auth.slice';
import { setSendbirdAccessToken } from 'src/features/chat/chat.slice';

export function useChangeOrganization() {
  const dispatch = useAppDispatch();

  const handleChangeOrganization = useCallback(
    (organizationId: string) => {
      dispatch(authSlice.actions.changeOrganization(organizationId));
      dispatch(
        setSendbirdAccessToken({
          membershipId: '',
          sendbirdAccessToken: '',
        })
      );
      dispatch(authSlice.actions.setIsOrganizationChangeOpen(false));

      // TODO: Rework how we handle Sendbird.
      // Removing this causes the app to blow up when GroupChannelListHeader tries to read
      // from a null user. This happens for a few reasons:
      // 1. We end up with two or more Sendbird instances
      // 2. The one inside GroupChannelListHeader has a null user that's typed as always defined
      // 3. GroupChannelListHeader is rerendered before the chat component is unmounted
      // Apparently this happens not only on /chat, but anywhere in the app followed by opening chat.
      // Reloading as a workaround to lessen complaints from the web app side.
      // Leaving the rest of the
      // eslint-disable-next-line no-restricted-globals
      window.location.reload();

      // All our data is tied to the organization id with few exceptions
      // This invalidates and refetches with the new org id
      // This is no longer needed since we're reloading above, but important when
      // we figure out Sendbird
      // dispatch(enhancedBambiApi.util.resetApiState());
    },
    [dispatch]
  );

  return handleChangeOrganization;
}
